import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Avatar,
  Box,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import {
  AccountBalanceWallet,
  Person,
  Logout,
  Menu as MenuIcon,
  Language,
  Check,
  Translate,
  Lock,
} from "@mui/icons-material";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { connect } from "react-redux";
import { logoutUser } from "../../services/user/actions";
import { getSettings } from "../../services/settings/actions";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@mui/joy";
import { set } from "date-fns";
import { Button } from "react-bootstrap";
import apiCall from "../../helpers/api";
import { CHANGE_PASSWORD_API_URL } from "../../configs/url";
import $ from "jquery";

const Header = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const theme = useTheme();
  const { user, settings } = props;
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLangMenu(false);
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [profileMenu, setProfileMenu] = useState(false);
  const [langMenu, setLangMenu] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const handleProfileClick = (event) => {
    setProfileMenu(event.currentTarget);
  };

  const handleLangMenuClick = (event) => {
    setLangMenu(event.currentTarget);
  };

  const handleChangePasswordModal = () => {
    setChangePasswordModal(true);
  };

  useMemo(() => {
    if (props?.user?.data?.last_login == null) {
      // handleChangePasswordModal();
    }
  }, [props?.user]);

  const handleChangePassword = async () => {
    if (newPassword !== confirmNewPassword) {
      enqueueSnackbar(t("passwordMismatch"), { variant: "error" });
      return;
    }

    enqueueSnackbar(t("passwordChanging"), { variant: "warning" });
    $("#changePassBtn").prop("disabled", true);
    apiCall({
      url: CHANGE_PASSWORD_API_URL,
      method: "POST",
      data: {
        password: newPassword,
      },
    })
      .then((response) => {
        if (response?.data?.success) {
          enqueueSnackbar(t("passwordChanged"), { variant: "success" });
          handleClose();
          $("#changePassBtn").prop("disabled", false);
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error" });
          $("#changePassBtn").prop("disabled", false);
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.response?.data?.message, { variant: "error" });
        $("#changePassBtn").prop("disabled", false);
      });
  };

  const handleClose = () => {
    setProfileMenu(false);
    setLangMenu(false);
    setChangePasswordModal(false);
  };

  const handleLogout = async () => {
    await props?.logoutUser();
    window.location.href = "/login";
  };

  return (
    <AppBar position="fixed" className="header-appbar">
      <Toolbar className="header-toolbar">
        <Box className="header-left">
          {isMobile && (
            <IconButton
              onClick={props.onMenuClick}
              className="header-menu-button"
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box className="header-logo-container">
            <img
              src="/images/kpg-logo.png"
              alt="Logo"
              className="header-logo"
            />
          </Box>
        </Box>

        <Box className="header-right">
          {!isMobile && (
            <>
              <Box className="header-wallet">
                <AccountBalanceWallet className="header-wallet-icon" />
                <Typography variant="body1" className="header-wallet-balance">
                  <span>
                    {settings[5].value} {props?.user?.wallet_balance ?? "0.00"}
                  </span>
                </Typography>
              </Box>
            </>
          )}
          <IconButton
            onClick={handleLangMenuClick}
            className="header-profile-button"
          >
            <Avatar className="header-profile-avatar">
              <Translate />
            </Avatar>
          </IconButton>

          <IconButton
            onClick={handleProfileClick}
            className="header-profile-button"
          >
            <Avatar className="header-profile-avatar">
              <Person />
            </Avatar>
          </IconButton>
        </Box>

        <Menu
          anchorEl={profileMenu}
          open={Boolean(profileMenu)}
          onClose={handleClose}
          PaperProps={{
            className: "header-profile-menu",
          }}
        >
          <MenuItem onClick={handleChangePasswordModal} className="header-item">
            <Box className="header-logout-content">
              <Lock className="header-change-password-icon" />
              <Typography className="header-text">
                {t("changePasswordText")}
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem onClick={handleLogout} className="header-logout-item">
            <Box className="header-logout-content">
              <Logout className="header-logout-icon" />
              <Typography className="header-logout-text">
                {t("logoutText")}
              </Typography>
            </Box>
          </MenuItem>
        </Menu>
        <Menu
          anchorEl={langMenu}
          open={Boolean(langMenu)}
          onClose={handleClose}
          PaperProps={{
            className: "header-profile-menu",
          }}
        >
          <MenuItem onClick={() => changeLanguage("en")}>
            <span className="d-flex justify-content-between align-items-center">
              English{" "}
            </span>
          </MenuItem>
          <MenuItem onClick={() => changeLanguage("th")}>
            <span className="d-flex justify-content-between align-items-center">
              ไทย{" "}
            </span>
          </MenuItem>
        </Menu>
        <Dialog
          open={changePasswordModal}
          onClose={handleClose}
          className="change-password-dialog"
        >
          <DialogTitle>{t("changePasswordText")}</DialogTitle>
          <DialogContent>
            <TextField
              label={t("changePasswordNewPassText")}
              type="password"
              fullWidth
              variant="outlined"
              margin="normal"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete={false}
            />
            <TextField
              label={t("changePasswordConfirmPassText")}
              type="text"
              fullWidth
              variant="outlined"
              margin="normal"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              autoComplete={false}
            />
          </DialogContent>
          <DialogActions>
            <button onClick={handleClose} class="btn btn-light">
              {t("common_cancel")}
            </button>
            <button
              onClick={handleChangePassword}
              class="btn btn-primary"
              id="changePassBtn"
            >
              {t("changePasswordText")}
            </button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  settings: state.settings.settings,
});

const mapDispatchToProps = {
  logoutUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
